import { render } from "./MultiSelectChips.vue?vue&type=template&id=6273c4aa&scoped=true&ts=true"
import script from "./MultiSelectChips.vue?vue&type=script&lang=ts"
export * from "./MultiSelectChips.vue?vue&type=script&lang=ts"

import "./multiselect-input.scss?vue&type=style&index=0&id=6273c4aa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6273c4aa"]])

export default __exports__